import cn from 'classnames';
import styles from './nft-divided.module.css';

function NFTDivided({ className, ...props }: { className?: string }) {
  return <div className={cn(styles.divided, className)} {...props} />;
}

export default NFTDivided;
